import { render, staticRenderFns } from "./FeedbackQuestion.vue?vue&type=template&id=56547719&scoped=true"
import script from "./FeedbackQuestion.vue?vue&type=script&lang=js"
export * from "./FeedbackQuestion.vue?vue&type=script&lang=js"
import style0 from "./FeedbackQuestion.vue?vue&type=style&index=0&id=56547719&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56547719",
  null
  
)

export default component.exports